import React from 'react';
import './TransactionCards.css';

function TransactionCards({ transactions, formatDate }) {
  return (
    <div className="transaction-cards">
      {transactions.map((txn) => (
        <div key={txn.id} className="transaction-card">
          <div className="txn-card-header">
            <span className="txn-card-type">{txn.type}</span>
            <span className={`txn-card-amount ${(txn.amount || 0) >= 0 ? 'txn-positive' : 'txn-negative'}`}>
              {(txn.amount || 0) >= 0 ? '+' : ''}{txn.amount || 0} credits
            </span>
          </div>
          <p className="txn-card-desc">{txn.description}</p>
          <div className="txn-card-footer">
            <span className="txn-card-date">{formatDate(txn.created_at)}</span>
            <span className="txn-card-balance">Balance: {txn.balance_after || 0}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TransactionCards;
